package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2025_11_08_Day_1() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We return to our heroes who have returned to Bondōvriar, planning to stock up and hit the road again.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("While the group planned to visit 4M, Caper convinces them to first visit Flip Chittle’s, a leatherworker shop run by a wood elf man named Flip. Caper orders a pink thong; Tuesday receives a referral to “Twinkle,” a shop that sells gems; and Annette sells some armor-grade chitin.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("On the way to 4M, the heroes pass some venders selling mystery meat, noodles, and chicken feet. Bigglesworth buys two helpings of “street-feet food.” At 4M, the heroes acquire the bags of holding that they were planning on buying and some other magical impulse buys like a Chime of Opening. Dirk purchases a 10 inch ebony wood blank.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("On the way to Twinkle’s, Falorn buys the heroes lunch. Bigglesworth and Korvis feel like they are being watched. Twinkles is run by a Scottish Tiefling named Shallah with a distinctive pierced nose. Tuesday buys a star ruby.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The heroes return to Flip Chittles to pickup Caper’s order. She uses the pink thong as a necklace to hold the key of Kharzak.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The heroes arrive at the Power Glow guild. Zordie nags the heroes about announcing their travel prior to teleporting. The heroes nod and say “of course we will announce our travel plans” (they will not). The heroes teleport to Freeburg.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The Freeburg Power Glow guild basement is huge, the size of gymnasium. They meet a brown-haired, black eyed, human woman named Magister Vivian Huff and her assistant Jaber from whom they learn about Freeburg and recent events:")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Freeburg is run by an Archduke named Malibu Go and advised by Dukes.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Dukes are elected.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("The independence of the city is respected. People assume that if the Dorvidian army entered the city that the Dwarves would respond.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Teleport to Dorvid remains impossible due to anti-magic zone.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Elrovir Rodiridan(Lady Aventary’s husband) sailed from Freeburg to Kostigan in Ostvel.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("City has more city watch than any city the heroes have seen.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Nearest Groove is in nearby Zeffa. It’s not labeled on Korvis’s map, but Jabar says it’s near the ‘F’ in Freeburg.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("An expert craftsman named “Rengel” could work Dirk’s ebony wood blank.")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The heroes arrive at the Leaping Ram, a 2 story building with big double doors and fancy leather seats — an upgrade in quality over the Courthammer franchise inns the heroes normally visit. Lornella Dabrin runs the inns. The heroes go to their room to scry the shards of the Shield of Concar. Now that they’re closer to the Freeburg shard, they can sense that it is stationary, about 7 or 8 miles away from their inn. Perhaps in an chest or on display?")
    }
}
